import React from 'react';

const ReturnIcon = (): JSX.Element => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18.5715 9.89256C18.5715 15.0354 14.8086 18.464 10.1663 18.464C6.39321 18.464 3.34863 16.4626 2.28578 13.3211M1.42863 9.89256C1.42863 4.74971 5.19149 1.32114 9.83378 1.32114C13.6078 1.32114 16.6515 3.32256 17.7143 6.46399" stroke="black" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.71427 14.1783L2.2857 13.3211L1.42856 16.7497M14.2857 5.60686L17.7143 6.464L18.5714 3.03543" stroke="black" strokeWidth="1.71429" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);

export default ReturnIcon;
